import request from '@/api/request'

// 机构查询
export function queryEquipmentInfo(params) {
  return request({
    url: `/EquipmentInfo?securityCode=${params}`,
    method: 'post'
  })
}
// 防伪码查询
export function querySecurityCode(params) {
  return request({
    url: `/securityCode?securityCode=${params}`,
    method: 'post'
  })
}

// 专业人士查询
export function queryRecognitionPerson(params) {
  return request({
    url: `/RecognitionPerson?securityCode=${params}`,
    method: 'post'
  })
}

// 微信配置查询
export function queryWxConfig(params) {
  return request({
    url: `/config?signUrl=${params}`,
    method: 'post'
  })
}
